import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import styles from './style.module.scss';

export interface IBulkUpdateProps {
    showDeleted: boolean;
}

const ToggleDeletedRecordsIcon = ({ showDeleted }: IBulkUpdateProps) => {
    return (
        <div className={cn('k-d-flex fa-stack', styles.iconStyle)}>
            <FontAwesomeIcon className={cn('fa-stack-1x')} fontSize={16} icon={['far', 'trash']} />
            <FontAwesomeIcon
                className={cn('fa-stack-1x')}
                fontSize={13}
                icon={showDeleted ? ['far', 'eye'] : ['far', 'eye-slash']}
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '1px 0px',
                    position: 'absolute',
                    top: '40%',
                    left: '40%',
                }}
            />
        </div>
    );
};

export default ToggleDeletedRecordsIcon;
